import React from 'react'
import '../styles/index.scss'

import Header from './header'
import Footer from './footer'
import layoutStyles from '../styles/components/siteLayout.module.scss'

const Layout = (props) => {
    return (
    <div className={layoutStyles.wrapper}>   
        <Header />
        <div className={layoutStyles.container}>
            <div className={layoutStyles.content}>
                {props.children}
            </div>
        </div>
        <Footer />
    </div> 
    )
}

export default Layout